import { render, staticRenderFns } from "./hqStuPositionApplyShow.vue?vue&type=template&id=be2d46e0&scoped=true"
import script from "./hqStuPositionApplyShow.vue?vue&type=script&lang=js"
export * from "./hqStuPositionApplyShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2d46e0",
  null
  
)

export default component.exports